import React from "react";
import classes from "./TriangleRow.module.scss";

const TriangleRow: React.FC<{
  canvasRef: React.RefObject<HTMLCanvasElement>;
}> = ({ canvasRef }) => <canvas className={classes.canvas} ref={canvasRef} />;

export default TriangleRow;
